import './PickerInfoBox.css';
import * as React from "react";
import PropTypes from "prop-types";

const CHILD_PROP = "value";
const CHILD_TEXT_PROP = "text";

PickerInfoBox.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object),
    current: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    warnings: PropTypes.arrayOf(PropTypes.string),
    onChangeCurrent: PropTypes.func,
    sticky: PropTypes.bool
}

export default function PickerInfoBox(props) {
    function getCurrent(value) {
        if (value == null) {
            return null;
        }
        if (typeof value === "object") {
            value = value[CHILD_PROP]
        }
        const found = props.options.find(option => option.value === value);
        if (found == null) {
            return null;
        }
        return found;
    }

    const info = getCurrent(props.current)?.text;

    if (info == null) {
        return null;
    }

    const warning = props.warnings == null || props.warnings.length <= 0
        ? null
        : <span className="picker-box-warning">{props.warnings[0]}</span>;

    const isInput = getCurrent(props.current)?.withInput;
    return (
        <>
            <div className={"info-picker-box " + (isInput ? "input " : "") + (props.sticky ? "sticky" : "")}>
                {isInput
                    ? <textarea
                        placeholder={info}
                        onChange={(e) => {
                            props.onChangeCurrent({...props.current, text: e.currentTarget.value})
                        }} className="info-picker-textarea"
                        value={props.current[CHILD_TEXT_PROP]}/>
                    : <p>
                        {info}
                        {warning != null ? <><br/>{warning}</> : null}
                    </p>
                }
            </div>
            {props.sticky ?
                <div className={"info-picker-box placeholder " + (isInput ? "input " : "")}>
                    {isInput
                        ? <textarea
                            placeholder={info}
                            onChange={(e) => {
                            }} className="info-picker-textarea"
                            value={props.current[CHILD_TEXT_PROP]}/>
                        : <p>
                            {info}
                            {warning != null ? <><br/>{warning}</> : null}
                        </p>
                    }
                </div>
                : null}
        </>
    );
}